// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { platformReadOnlyFetch } from '@/lib/platformReadOnlyBoundary';
import { pickAuthStorage } from '@/lib/sharedAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  global: { fetch: platformReadOnlyFetch },
  auth: {
    // One sign-in across every *.thepolishedversion.com address (see sharedAuthStorage.ts).
    storage: pickAuthStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});